import DispensaryProductPage from 'src/dispensary/product';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { createStorePageServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';
import { prefetchPdpProductIfEnabled } from 'src/utils/ssr/prefetch-pdp-product';

// Product prefetch is gated by its own LD flag (STORES_SSR_PDP_PRODUCT_FLAG) nested under the main
// stores-ssr rollout: the dispensary shell hydrates first, and the PDP's own product layers in when
// that flag is on.
export const getServerSideProps = createStorePageServerSideProps(prefetchPdpProductIfEnabled);

DispensaryProductPage.layout = CoreMenuLayout;
export default DispensaryProductPage;
